// Bloco "Na fila · N" acima do campo de mensagem: o que o usuário digitou enquanto a IA respondia (só desta conversa, só em memória).
// Estado e transições vivem em `chatQueue.ts`; aqui só a apresentação. Pausada ("Fila pausada · N"): Continuar retoma do primeiro item, Limpar descarta.
import { CornerDownRight, Play, Trash2 } from 'lucide-react';
import type { Item } from '../chatQueue';

const plural = (n: number, one: string, many: string) => `${n} ${n === 1 ? one : many}`;
const snippet = (it: Item) => { const t = (it.text || 'imagem').replace(/\s+/g, ' ').trim(); return t.length > 40 ? `${t.slice(0, 40)}…` : t; };
const attach = (it: Item) => [it.images.length ? plural(it.images.length, 'imagem', 'imagens') : '', it.documentIds.length ? plural(it.documentIds.length, 'documento', 'documentos') : ''].filter(Boolean).join(' · ');

export function ChatQueue({ queue, paused, onRemove, onSendNow, onResume, onClear }: {
  queue: Item[]; paused: boolean;
  onRemove: (key: number) => void; onSendNow: (key: number) => void; onResume: () => void; onClear: () => void;
}) {
  if (!queue.length) return null;
  return (
    <div className={`queue${paused ? ' paused' : ''}`} role="region" aria-label="Mensagens na fila">
      <div className="queue-h">
        <span className="queue-t">{paused ? 'Fila pausada' : 'Na fila'} · <b>{queue.length}</b></span>
        <span className="queue-hint">vale só nesta conversa</span>
        {paused && (
          <div className="queue-acts">
            <button type="button" className="btn sm primary" onClick={onResume}><Play />Continuar</button>
            <button type="button" className="btn sm ghost" onClick={onClear}>Limpar</button>
          </div>
        )}
      </div>
      <ol>
        {queue.map((it, i) => (
          <li key={it.key}>
            <span className="queue-n" aria-hidden="true">{i + 1}</span>
            <div className="queue-body">
              <span className="queue-txt" title={it.text}>{it.text || 'Descreva esta imagem em detalhes.'}</span>
              {attach(it) && <span className="queue-att">{attach(it)}</span>}
            </div>
            <div className="queue-btns">
              <button type="button" className="queue-btn danger" aria-label={`Apagar da fila: ${snippet(it)}`} onClick={() => onRemove(it.key)}><Trash2 />Apagar</button>
              <button type="button" className="queue-btn" aria-label={`Enviar agora: ${snippet(it)}`} onClick={() => onSendNow(it.key)}><CornerDownRight />Enviar agora</button>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}
